import { render, staticRenderFns } from "./ChangeAddressModal.vue?vue&type=template&id=90794b4e&"
import script from "./ChangeAddressModal.vue?vue&type=script&lang=ts&"
export * from "./ChangeAddressModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports